import { graphql, navigate } from 'gatsby'
import React from 'react'
import Layout from '../components/layout'
import ProtectedPage from '../components/ProtectedPage/ProtectedPage'
import Seo from '../components/seo'
import BlockReturn from '../function/ReturnBlock'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import HotJarScript from '../scripts/HotjarScript'
import FormWrapper from '../components/CyberSecurityAssessment/FormWrapper'
function CreatePages({ data, pageContext, location }) {
    const blocks = data?.page?.blocks
    const cyberSecurityAssessment = data?.page?.cyberSecurityAssessment?.useCase?.question !== null;
    if (cyberSecurityAssessment) {
        console.log('CyberSecurityAssessment template')
    }
    if (blocks[0]?.name === undefined || blocks?.length === 0) {
        return (
            <ProtectedPage
                password={pageContext?.password}
                enablePasswordProtected={pageContext?.enablePasswordProtected}
            >
                <Layout>
                    <div
                        className="container"
                        style={{
                            textAlign: 'center',
                            fontSize: '35px',
                            lineHeight: '35px',
                            fontWeight: '700',
                            margin: '70px auto'
                        }}
                    >
                        Page doesn't have any content yet, please add content
                        from WP editor.
                    </div>
                </Layout>
            </ProtectedPage>
        )
    } else {
        const pageId = pageContext?.id.replace(/[^a-zA-Z0-9]/g, '')

        return (
            <ProtectedPage
                password={pageContext?.password}
                enablePasswordProtected={pageContext?.enablePasswordProtected}
            >
                <ToastContainer />
                <Layout
                    mode={pageContext?.theme ? 'light' : 'dark'}
                    pageId={pageId}
                >
                    <div className={` mx-auto ${pageContext?.slug}`}>
                        {blocks.length > 0 && <BlockReturn blocks={blocks} />}
                    </div>
                    {cyberSecurityAssessment && <FormWrapper data= {data?.page?.cyberSecurityAssessment}/>}
                </Layout>
            </ProtectedPage>
        )
    }
}
export const Head = ({ data, location }) => {
    const defaultDesc =
        'Celerity is a UK trusted IT services provider delivering intelligent cybersecurity, data protection & data visualisation services for companies.'
    const { seo, title, featuredImage } = data?.yoastSeo

    const metaDesc = seo?.metaDesc || `${title} | ${defaultDesc}`
    return (
        <>
            {location.pathname === '/cyber-security-maturity-assessment/' && (
                <HotJarScript />
            )}
            <Seo
                title={seo?.title}
                description={metaDesc}
                image={featuredImage?.node?.sourceUrl}
                props={seo}
            />
        </>
    )
}
export default CreatePages
export const query = graphql`
    query ($id: String!) {
        page: wpPage(id: { eq: $id }) {
            ...Layout
            cyberSecurityAssessment {
                useCase {
                question
                description
                image {...image}
                    options {
                        text
                    }
                }
                questionnaire {
                    steps {
                        step {
                            title
                            uniqueName
                            questions {
                                text
                            }
                        }
                    }
                }
                statistic {
                    partiallyExists
                    notImplemented
                    inComplete
                    fullyDeployedOptimised
                    fullyDeployed
                }
                form {
                    title
                    portalId
                    formId
                }
            }
        }
        yoastSeo: wpPage(id: { eq: $id }) {
            featuredImage {
                node {
                    sourceUrl
                }
            }
            title
            seo {
                title
                canonical
                metaDesc
                focuskw
                opengraphTitle
                opengraphDescription
                twitterTitle
                twitterDescription
                metaRobotsNofollow
            }
        }
            
    }
`
